import { StageStatus, TaskStatus } from 'common/types';

export const TaskStatusMap: Record<
  TaskStatus | StageStatus,
  {
    text: string;
    color: string;
    className: string;
  }
> = {
  [TaskStatus.AllStatus]: {
    text: '全部版本',
    color: 'var(--status-gray)',
    className: 'all',
  },
  [StageStatus.PendingProcessing]: {
    text: '未开始',
    color: 'var(--status-gray)',
    className: 'pending-processing',
  },
  [StageStatus.PendingInternalCheck]: {
    text: '待审核',
    color: 'var(--status-yellow)',
    className: 'pending-internal-check',
  },
  [StageStatus.PendingIterate]: {
    text: '待修改',
    color: 'var(--status-red)',
    className: 'pending-iterate',
  },
  [TaskStatus.Processing]: {
    text: '待提交',
    color: 'var(--status-blue)',
    className: 'processing',
  },
  [TaskStatus.Accepted]: {
    text: '已验收',
    color: 'var(--status-green)',
    className: 'pass',
  },
  [TaskStatus.Settling]: {
    text: '结算中',
    color: 'rgba(228, 159, 75, 0.7)',
    className: 'settling',
  },
  [StageStatus.Pass]: {
    text: '已通过',
    color: 'var(--status-green)',
    className: 'pass',
  },
  [TaskStatus.End]: {
    text: '已结束',
    color: 'var(--status-gray)',
    className: 'paused',
  },
};

export const localStorageCommentKey = 'eeveeCachedComment';

export enum TaskQueryKey {
  GroupName = 'GROUP_NAME', //搜索对象组名称
  TaskSubject = 'TASK_SUBJECT', //搜索对象为父任务名称
  Users = 'USERS', // 搜索对象为【需求方】、【审核方】、【制作方】的昵称
  Activity = 'ACTIVITY', //搜索对象为活动名称
}

// 任务列表排序字段
export enum TaskSortKey {
  CreateTime = 'CREATE_TIME', // 按创建时间
  TaskSubject = 'TASK_SUBJECT', // 按任务名(服务端自然排序)
}

// 任务列表排序方向
export type TaskSortOrder = 'desc' | 'asc';

export const FreeCredit = '-1';
export const MAX_TASK_SUBJECT_LENGTH = 70; // 任务名称最大长度
export const MAX_VERSION_DESCRIPTION_LENGTH = 1000; // 版本描述最大长度

export const TradeModeTextMap = {
  personal: '个人任务',
  entrust: '企业委托任务',
};
